import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import { useEffect } from "react";
import ProgressButtons from "../ProgressButtons";
import SubFormButtons from "../SubFormButtons";
import countriesList from "../../../data/countriesList";
import livingStatusList from "../../../data/livingStatusList";

import PreferredPronouns from "../../../data/PreferredPronouns";
import states from "../../../data/states";


const R22StudentPreferences = () => {
  const [otherPreferredPronouns, setOtherPreferredPronouns] = useState("");

  const registrationContext = useContext(RegistrationContext);
  const {
    subFormLevels,
    onFormDataChange,
    pass: { studentPreference },
    formData: {
      studentName,
      preferredpronouns,
      otherpreferredpronouns,
      firstName,
      street,
      city,
      state,
      zip,
      isMailingAddressTheSame,
    },
  } = registrationContext;

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const [county, setcounty] = useState("United States of America");
  const handleChange2 = (e) => {
    setcounty(e.target.value);
    onFormDataChange(e);
  };

  const validatezipCode = (e) => {
    const re = /^\d{5}$/;
    return re.test(String(e).toLowerCase());
  };

  const handleChange1 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      var aVal = e.target.value;
      if (aVal.length < 5) {
        e.target.value = aVal;
      }
    }
    onFormDataChange(e);
  };

  const studentPreferenceFilled = "";
  // studentName !== "" &&    preferredpronouns !== "" &&
  // otherpreferredpronouns !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          Student Preference <span>(2/11)</span>
          <hr />
        </h2>
        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "the Student" : firstName}'s Preferred
              Name?
            </h3>
          </div>
          <input
            type="text"
            name="studentName"
            maxLength="50"
            onChange={(e) => onFormDataChange(e)}
            value={studentName}
          />
        </div>

        <div className="item">
          <div className="asterisk-group">
            <h3>
              What is {firstName === "" ? "The Student's" : firstName}'s
              Preferred Pronouns?
            </h3>
          </div>
          <select
            name="preferredpronouns"
            value={preferredpronouns}
            onChange={(e) => onFormDataChange(e)}
            // style={{
            //   border: studentInformation
            //     ? "2px solid #ccc;"
            //     : preferredpronouns !== ""
            //     ? "2px solid #ccc"
            //     : "#d8302f 2px solid",
            // }}
          >
            <option value="">Please Select </option>
            {PreferredPronouns.map((item) => {
              return <option value={item}>{item}</option>;
            })}
          </select>
        </div>
      </div>
      <div className="group">{subFormLevels.physicalAddress === 0}</div>
      <ProgressButtons
        validation={!studentPreferenceFilled}
        name="studentPreference"
      />
    </>
  );
};

export default R22StudentPreferences;
